import { ca } from '@cian/analytics';

import { getPlaceType } from './getPlaceType';
import { TProduct } from '../../../types/analytics';

interface ITrackOpenChatParams {
  label: string;
  product: TProduct;
  isPromoSnippet?: boolean;
}

export function trackOpenChat({ label, product, isPromoSnippet }: ITrackOpenChatParams) {
  ca('eventSite', {
    action: 'open',
    category: 'Message_popup',
    label,
    name: 'oldevent',
    products: [product],
    page: {
      extra: {
        type: getPlaceType(isPromoSnippet),
      },
    },
  });
}
